<a
  class="toolbar-menu-item"
  [routerLink]="item().url"
  [ngClass]="{ last: last() }"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: false }"
  (mouseover)="setState('open')"
  (mouseleave)="setState('close')"
>
  @if (item().icon) {
    <span
      class="toolbar-menu-item-icon"
      [ngClass]="item().icon"
    ></span>
  }

  <span class="toolbar-menu-item-name">{{ item().name | hardTranslate }}</span>

  @if (item()?.children?.length) {
    <span class="toolbar-menu-item-arrow icon-arrow-down"></span>

    <div
      [@itemState]="state()"
      class="toolbar-menu-item-children"
    >
      <div class="toolbar-menu-child-content">
        @for (child of item().children; track child.id) {
          <a
            class="toolbar-menu-child-content-row"
            [routerLink]="child.url"
            stop-propagation
            (click)="child?.url ? setState('close') : null"
          >
            <span
              class="toolbar-menu-child-content-row-icon"
              [ngClass]="child.icon"
            ></span>

            <span class="toolbar-menu-child-content-row-name">
              {{ child.name | hardTranslate }}
            </span>
          </a>
        }
      </div>
    </div>
  }
</a>
